import { Component, computed, Inject, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormTranslator } from 'app/common/services/translation.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { SectorAppService } from 'app/modules/sector';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-thematics-create',
    imports: [ReactiveFormsModule, TranslocoModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatTooltipModule, MatSelectModule],
    templateUrl: './thematic-create.component.html'
})
export class ThematicCreateComponent {
    private readonly sectorAppService = inject(SectorAppService);

    private readonly dialogRef = inject(MatDialogRef<ThematicCreateComponent>);
    trans: FormTranslator;

    sectors = toSignal(this.sectorAppService.getAllSectors(), { initialValue: [] });

    topSectors = computed(() =>
        this.sectors().filter(sector => !sector.parentSectorId)
            .map(sector => ({
                ...sector,
                subSectors: this.sectors().filter(sub => sub.parentSectorId === sector.id)
            }))
    );


    thematicForm = new UntypedFormGroup({
        nameFr: new FormControl<string | null>(null, [Validators.required]),
        nameEn: new FormControl<string | null>(null, [Validators.required]),
        descriptionFr: new FormControl<string | null>(null),
        descriptionEn: new FormControl<string | null>(null),
        isActive: new FormControl<boolean>(true),
        sectorId: new FormControl<string | null>(null, [Validators.required]),
    });

    constructor(@Inject(MAT_DIALOG_DATA) public data: { subSectorId: string | null }) {
        this.trans = new FormTranslator(this.thematicForm);
    }

    ngOnInit() {
        if (this.data.subSectorId) {
            this.thematicForm.patchValue({ sectorId: this.data.subSectorId });
        }
    }

    onSubmit() {
        if (this.thematicForm.valid) {
            const formData = this.thematicForm.value;
            this.dialogRef.close(formData);
        } else {
            console.warn('Form is invalid');
        }
    }

    onCancel() {
        this.dialogRef.close(false);
    }
}